export default __webpack_public_path__ + "static/media/chata.28b16260.png";